<template>
  <div class="profile">
    <div class="user-image">
      <div v-if="userData.wall_paper" class="user-image relative" :style="`background-image: url(${userData.wall_paper})`">
        <div v-if="$route.params.name == $store.state.account.name" class="edit" @click="isEdit=true">
          <i class="fa fa-pencil-square-o"></i>
        </div>
      </div>
      <div v-else for="wall_paper" class="user-image def-camera relative">
        <div v-if="$route.params.name == $store.state.account.name" class="edit" @click="isEdit=true">
          <i class="fa fa-pencil-square-o"></i>
        </div>
      </div>
      <div class="user-cover">
        <div v-if="userData.icon_img" class="icon-label" :style="`background-image: url(${userData.icon_img})`">
        </div>
        <div v-else for="icon_img" class="icon-label def-camera" >
        </div>
        <p class="account-name">{{userData.screen_name}}</p>
        <p class="account-id">@{{userData.name}}</p>
      </div>
    </div>
    <!-- 自分から見た時 -->
    <div v-if="$route.params.name == $store.state.account.name" class="profile-wrapper">
      <card>
        <div class="account-status">
          <p>{{lang[0]}}</p>
          <div class="flex relative">
            <p class="account-status-text">{{lang[1]}}
              <div class="mini-circle" :class="`${isBuyItem? 'complate-circle' : 'yet-circle'}`"></div>
            </p>
          </div>
          <div class="flex relative">
            <p class="account-status-text">{{lang[2]}}
              <div class="mini-circle" :class="`${isSellItem? 'complate-circle' : 'yet-circle'}`"></div>
          </div>
          <div class="flex relative">
            <p class="account-status-text">{{lang[3]}}
              <div class="mini-circle" :class="`${isRequestOrder? 'complate-circle' : 'yet-circle'}`"></div>
          </div>
          <div class="flex relative">
            <p class="account-status-text">{{lang[4]}}
              <div class="mini-circle" :class="`${isRequestRespond? 'complate-circle' : 'yet-circle'}`"></div>
          </div>
        </div>
      </card>
      <div class="flex">
        <card style="width: 50%;">
          <p>{{lang[5]}}</p>
          <p class="balance-text"><b>{{available}}</b> {{lang[7]}}</p>
        </card>
        <card style="width: 50%;">
          <p>{{lang[6]}}</p>
          <p class="balance-text"><b>{{pending}}</b> {{lang[7]}}</p>
        </card>
      </div>
      <p class="payout-explanation">{{lang[41]}}</p>
      <p class="account-title">{{lang[10]}}</p>
      <p class="stripe-caution">{{lang[11]}}</p>
      <!-- <div class="user-form">
        <p>email: </p>
        <input
        v-model="userData.email"
        type="text"
        >
      </div> -->

      <router-link to="/account/address">
        <card class="relative">
          <div class="flex">
            <div class="card-icon">
              <i class="fa fa-map-marker"></i>
            </div>
            <div>
              <p class="card-text">{{lang[12]}}</p>
              <div class="flex relative width-100">
                <p class="card-sub-text">{{addressInput}}/{{addressLen}} {{lang[13]}}</p>
              </div>
            </div>
            <div　class="circle" :class="`${isAddressComplate ? 'complate-circle' : 'yet-circle'}`"></div>
          </div>
          <div class="absolute account-progressbar" :style="`width: ${(addressInput/addressLen) *100}%`"></div>
        </card>
      </router-link>
      <div v-if="hasStripeId">
        <router-link to="/account/bank">
          <card class="relative">
            <div class="flex">
              <div class="card-icon">
                <i class="fa fa-money"></i>
              </div>
              <div>
                <p class="card-text">{{lang[14]}}</p>
                <div class="flex relative width-100">
                  <p class="card-sub-text">{{bankNull}}/{{bankLen}} {{lang[13]}}</p>
                </div>
              </div>
              <div　class="circle" :class="`${isBankComplate ? 'complate-circle' : 'yet-circle'}`" ></div>
            </div>
            <div class="absolute account-progressbar" :style="`width: ${(bankNull/bankLen) *100}%`"></div>
          </card>
        </router-link>
      </div>
      <div v-if="hasStripeId">
        <router-link to="/account/verification">
          <card class="relative">
            <div class="flex">
              <div class="card-icon">
                <i class="fa fa-id-card-o"></i>
              </div>
              <div>
                <p class="card-text">{{lang[15]}}</p>
                <div class="flex relative width-100">
                  <p class="card-sub-text">{{verificationNull}}/{{verificationLen}} {{lang[13]}}</p>
                </div>
              </div>
              <div　class="circle complate-circle" :class="`${isVerificationComplate ? 'complate-circle' : 'yet-circle'}`"></div>
            </div>
            <div class="absolute account-progressbar" :style="`width: ${(verificationNull/verificationLen) *100}%`"></div>
          </card>
        </router-link>
      </div>

      <btn size="normal" type="cancel" :label="lang[16]" @click="logout()" style="text-align: center;"></btn>
    </div>



    <!-- 他人から見た時 -->
    <div v-else class="profile-wrapper">
      <div class="p-20">
        <p class="detail-title">{{lang[19]}}: {{userData.country}}</p>
        <p class="detail-title">{{lang[20]}}: {{requests.length}}</p>
        <p class="detail-title">{{lang[21]}}: {{ideas.length}}</p>
        <p class="detail-title">{{lang[22]}}</p>
        <div class="flex">
          <div
            class="otaku-item"
            v-for="(val, key, index) in requestCount"
            :key="index"
            :style="`background-image: url(${val.img1})`"
            @click="moveDetail(val.id)"
          >
            <div class="name-label">
              <p>{{val.name}}</p>
            </div>
          </div>
        </div>

        <p class="detail-title m-t-20">{{lang[23]}}</p>
        <div class="flex">
          <div
            class="otaku-item"
            v-for="(val, key, index) in ideaCount"
            :key="index"
            :style="`background-image: url(${val.img1})`"
            @click="moveDetail(val.request_id)"
          >
            <div class="name-label">
              <p>{{lang[24]}}: {{val.price}} {{lang[7]}}<br>{{lang[25]}}: {{val.state? lang[26]: lang[27]}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal v-if="isEdit" @close="close">
      <div class="user-image">
        <label v-if="userData.wall_paper" for="wall_paper" class="user-image" :style="`background-image: url(${userData.wall_paper})`">
          <div v-if="uploading" class="fa-wrapper">
            <p class="center-absolute">
              <i class="fa fa-circle-o-notch fa-spin"></i>
            </p>
          </div>
        </label>
        <label v-else for="wall_paper" class="user-image def-camera" >
          <div v-if="uploading" class="fa-wrapper">
            <p class="center-absolute">
              <i class="fa fa-circle-o-notch fa-spin"></i>
            </p>
          </div>
        </label>
        <input
          id="wall_paper"
          type="file"
          name="file"
          accept="image/*"
          @change="selectedFile"
          style="opacity: 0;display: none;"
        >
        <div class="user-cover">
          <label v-if="userData.icon_img" for="icon_img" class="icon-label" :style="`background-image: url(${userData.icon_img})`">
            <div v-if="uploading" class="fa-wrapper">
              <p class="center-absolute">
                <i class="fa fa-circle-o-notch fa-spin"></i>
              </p>
            </div>
          </label>
          <label v-else for="icon_img" class="icon-label def-camera" >
            <div v-if="uploading" class="fa-wrapper">
              <p class="center-absolute">
                <i class="fa fa-circle-o-notch fa-spin"></i>
              </p>
            </div>
          </label>
          <input
            id="icon_img"
            type="file"
            name="file"
            accept="image/*"
            @change="selectedFile"
            style="opacity: 0;dipslay: none;"
          >
          <input class="account-name" v-model="userData.screen_name" @input="nullCheckVal">
          <p class="account-id">@{{userData.name}}</p>
        </div>
      </div>
      <div class="user-form">
        <n-input v-model="userData.email"
          :placeholder="lang[17]"
          type="email"
          @chargeRifleInput="nullCheckVal"
        >
        </n-input>
      </div>
      <div class="user-form">
        <n-select label="Select" v-model="userData.lang" :options="langArr" :placeholder="lang[18]"
        @nullCheckVal="nullCheckVal">
        </n-select>
      </div>

      <div class="btn-wrapper">
        <btn type="cancel" :label="lang[43]" size="normal" @click="close()"></btn>
        <btn type="primary" :label="lang[42]" size="normal" @click="update()" :loading="isLoading"></btn>
      </div>
    </modal>

    <app-menu active="profile"></app-menu>
    <notice v-if="isNotice" :title="noticeTitle" :text="noticeText" :type="noticeType"></notice>
  </div>
</div>
</template>

<script>
import axios from 'axios'
import Btn from '../../components/Button.vue'
import AppMenu from '../../components/Menu.vue'
import Notice from '../../components/Notice.vue'
import Card from '../../components/Card.vue'
import Modal from '../../components/Modal.vue'
import NInput from '../../components/Input.vue'
import NSelect from '../../components/Select.vue'
import stripeAddressMaster from '../../masters/stripeAddressMaster'
import stripeCountryMaster from '../../masters/stripeCountryMaster'
import AccountIndexLangMaster from '../../masters/langMaster/AccountIndexLangMaster'
import stripeErrorHandle from '../../mixins/stripeErrorHandle.js'

export default {
  name: 'Profile',
  components: {
    Btn,
    AppMenu,
    Notice,
    Card,
    Modal,
    NInput,
    NSelect,
  },

  data() {
    return {
      langArr: [{label: '日本語', value: 'ja'},{label: 'English', value: 'en'}],
      lang: AccountIndexLangMaster[this.$store.state.account.lang],
      userData: {
        icon_img: {type: String},
        id: {type: [String, Number]},
        name: {type: [String, Number]},
        screen_name: {type: [String, Number]},
        country: {type: String},
        email: {type: String},
        lang: {type: String},
      },
      available: 0,
      pending: 0,
      amount: Number,
      uploading: false,
      uploadFile: null,
      addressLen: 0,
      addressNull: 0,
      addressInput: 0,
      bankLen: 0,
      bankNull: 0,
      verificationLen: 2,
      verificationNull: 0,
      isAddressComplate: false,
      isBankComplate: false,
      isVerificationComplate: false,
      noticeTitle: '',
      noticeText: '',
      noticeType: '',
      isNotice: false,
      requests: [],
      ideas: [],
      isLoading: false,
      isEdit: false,
      isRequestOrder: false,
      isRequestRespond: false,
      isBuyItem:false,
      isSellItem:false,
      isPayoutModal: false,
      isConfirm: false,
      arrivalDate: "",
      payoutSuccess: false,
      hasStripeId: false,
      isSend: false,
    }
  },

  computed: {
    requestCount() {
      return this.requests.slice(0,2)
    },
    ideaCount() {
      return this.ideas.slice(0,2)
    },
  },

   created() {
    this.fetchData()
    if(stripeCountryMaster[this.$store.state.account.country] !== undefined) {
      this.isBuyItem = true
      this.isRequestOrder = true
    }
  },

  watch: {
    '$route' (to, from) {
      this.fetchData()
    }
  },

  methods: {
    fetchData() {
      if(this.$route.params.name !== this.$store.state.account.name) {
        axios.get(`private/user/${this.$route.params.name}`).then((data) => {
          this.userData = data.data.user
          this.getTradeData()
        }).catch(err => {
          console.log(err)
        })
      } else {
        axios.get(`private/user_id/${this.$store.state.account.id}`).then(data => {
          this.userData = data.data.user
          if(this.userData.stripe_id) {
            this.getBalance()
            this.getAccount()
            this.hasStripeId = true
          } else {
            this.nullCheckWithoutStripe()
            this.isLoading = false
          }
        }).catch(err => {
          console.log(err);
        });
      }
    },

    selectedFile(e) {
      this.uploading = true
      e.preventDefault();
      this.uploadFile = e.target.files[0];
      const uploadData = new FormData()
      uploadData.append('file', this.uploadFile)
      axios.post('private/aws/s3up', uploadData)
      .then((data) => {
        this.uploading = false
        this.userData[e.target.id] = data.data.name
      }).catch((err) => {
        this.uploading = false
        this.noticeType = 'alert'
        this.noticeTitle = 'Error'
        this.noticeText = err.message
        this.isNotice = true
        this.isLoading = false
        setTimeout(this.closeNotice,5000)
      });
    },

    update() {
      this.isLoading = true
      axios.put(`private/user/${this.userData.id}`, this.userData)
      .then((data) => {
        this.userData = data.data.updatedModel
        this.noticeType = 'success'
        this.noticeTitle = 'success!'
        this.noticeText = 'Your data has been succeffly updated!!'
        this.isNotice = true
        setTimeout(this.closeNotice,5000)
        localStorage.setItem('nerzex.user', JSON.stringify(data.data.updatedModel))
        this.$store.dispatch('account/find', JSON.parse(localStorage.getItem('nerzex.user')))
        this.close()
        this.$router.go({path: this.$router.currentRoute.path, force: true})
      }).catch((err) => {
        this.noticeType = 'alert'
        this.noticeTitle = 'Error'
        this.noticeText = err.message
        this.isNotice = true
        this.isLoading = false
        setTimeout(this.closeNotice,5000)
      });
    },

    closeNotice() {
      this.isNotice = false
    },

    logout() {
      localStorage.removeItem('nerzex.login')
      this.$store.dispatch('auth/logout');
    },

    getTradeData() {
      axios.get(`private/request/mylist/${this.userData.id}`)
      .then(data => {
        this.requests = data.data.model
      }).catch(err => {
        console.log(err)
      })

      axios.get(`private/idea/mylist/${this.userData.id}`)
      .then(data => {
        this.ideas = data.data.model
      }).catch(err => {
        console.log(err)
      })
    },

    getBalance() {
      axios.get(`private/stripe/balance/${this.$store.state.account.stripe_id}`)
      .then(data => {
        this.available = data.data.data.available[0].amount
        this.pending = data.data.data.pending[0].amount
      }).catch(err => {
        console.log(err)
      })
    },

    getAccount() {
      axios.get(`private/stripe/account/${this.$store.state.account.stripe_id}`)
      .then(data => {
        this.nullCheck(data)
        if(data.data.data.payouts_enabled) {
          this.isSellItem = true
          this.isRequestRespond = true
        }
      }).catch(err => {
        console.log(err)
      })
    },

    nullCheck(data) {
      let addressNullArr = []
      const currently_due = data.data.data.requirements.currently_due.filter(name => {
        return name.match(/individual/)
      })
      if(this.$store.state.account.country === "Japan") {
        this.addressLen = stripeAddressMaster['jp'].length
        this.bankLen = 4
        addressNullArr = stripeAddressMaster['jp'].filter(count => {
          return currently_due.includes(count)
        })
      } else {
        this.addressLen = stripeAddressMaster['us'].length
        this.bankLen = 3
        addressNullArr = stripeAddressMaster['us'].filter(count => {
          return currently_due.includes(count)
        })
      }
      this.addressNull = addressNullArr.length
      if(this.addressNull) {
        //通常時はthis.addressNullで入力されている数を入力項目数から引く
        this.addressInput = this.addressLen - this.addressNull
      } else {
        //何も入力されていなくて、this.addressNullが0になってしまう場合
        this.addressInput = this.addressNull
      }

      //全部の住所が入力されている時
      if(this.addressNull === data.data.data.requirements.currently_due.length ||
        data.data.data.requirements.currently_due.length==1 &&
        data.data.data.requirements.currently_due[0] === "external_account") {
        this.addressInput = this.addressLen
        this.isAddressComplate = true
      }

      if(data.data.data.external_accounts.data.length) {
        this.bankNull = 4
        this.bankLen = 4
        this.isBankComplate = true
      } else {
        this.bankNull = 0
        this.bankLen = 4
      }

      const verificationArr = ['front', 'back']
      const verificationNullArr = verificationArr.filter(count => {
        return data.data.data.individual.verification.document[count] !== null
      })
      this.verificationNull = verificationNullArr.length
      if(this.verificationNull === 2) {
        this.isVerificationComplate = true
      }
    },

    nullCheckWithoutStripe() {
      const addressMasterArr = ['post_code', 'prefecture', 'street', 'address', 'line1', 'first_name', 'last_name', 'year', 'month', 'day', 'gender', 'phone_number']
      this.addressLen = addressMasterArr.length
      const addressNullArr = addressMasterArr.filter(count => {
        return this.userData[count]
      })
      this.addressNull = addressNullArr.length
      this.addressInput = this.addressNull
      if(this.addressNull === 12) {
        this.isBuyItem = true
        this.isRequestOrder = true
        this.isAddressComplate = true
      }
    },

    moveDetail(id) {
      this.$router.push(`/request/${id}`)
    },

    close() {
      this.isEdit = false
      this.isPayoutModal = false
      this.payoutSuccess = false
    },

    nullCheckVal() {
      let checkArr = ['lang', 'email', 'screen_name']
      for(let i=0, len=checkArr.length; i < len; i++) {
        if(!this.userData[checkArr[i]]) {
          this.isSend = false
          return false
        } else {
          this.isSend = true
        }
      }
    }
  },
};
</script>

<style scoped>
.profile {
  margin-bottom: 90px
}

.user-image {
  position: relative;
  width: 100%;
  height: 200px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.user-cover {
  height: 90px;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  bottom: 0;
  z-index: 1;
}

.icon-label {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  border: 2px solid #F39939;
  background-size: contain;
  position: absolute;
  bottom: 10px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;left: 5px;
}

.icon-label .fa-wrapper {
  border-radius: 50%;
}

.account-name {
  color: #fff;
  position: absolute;
  bottom: 35px;
  left: 80px;
  font-size: 20px;
  line-height: 0;
  padding: 0;
  border: none;
  background: transparent;
}

.account-id {
  color: #fff;
  position: absolute;
  bottom: 5px;
  left: 80px;
  font-size: 12px;
}

.account-title {
  margin: 20px;
  font-size: 20px;
  font-weight: bold;
}

#icon-upload {
  display: none;
}

.user-form {
  margin: 20px;
  display: flex;
}

.select-wrapper::after {
  right: 0%;
}

.card-icon {
  font-size: 45px;
  background: #fff;
  padding: 0 10px;
  border-radius: 5px;
  height: fit-content;
  min-width: 70px;
}

.card-text {
  margin-left: 15px;
  font-size: 14px;
  margin-top: 5px;
  font-weight: bold;
}

.card-sub-text {
  font-size: 14px;
  margin-left: 15px;
}

.complate-circle {
  background: #a9d053;
}

.yet-circle {
  background: #e33830;
}

.circle {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-left: 30px;
  position:absolute;
  right: 45px;
  top: 45px;
}

.mini-circle {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  position:absolute;
  right: 10%;
}

.account-progressbar {
  bottom: 0;
  width: 100%;
  height: 2px;
  background: #f3983b;
  left: 0;
  border-radius: 5px;
}

.edit {
  font-size: 28px;
  position: absolute;
  top: 5%;
  right: 5%;
  color: #fff;
  background: #f3983b;
  border-radius: 50%;
  height: fit-content;
  padding: 1px 10px;
}

.balance-text {
  margin-bottom: 0!important;
}

.account-status-text {
  margin-bottom: 0!important;
  font-size: 14px;
}

.modal-icon-wrapper {
  text-align: center;
  margin-bottom: 20px;
}

.modal-icon {
  width: 200px;
}

.modal-title {
  font-size: 16px;
  font-weight: bold;
  text-align: center;
}
.payout-explanation {
  margin: 0 auto;
  width: 90%;
  font-size: 14px;
}

.stripe-caution {
  font-weight: bold;
  font-size: 16px;
  margin: 20px;
}

@media(min-width: 800px) {
  .user-image {
    height: 30vh;
  }

  .profile-wrapper {
    width: 90%;
    max-width: 800px;
    margin: 40px auto;
  }

  .user-cover {
    height: 120px;
    width: 100%;
    background: rgba(0, 0, 0, 0.5);
    position: absolute;
    bottom: 0;
    z-index: 1;
  }

  .icon-label {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    border: 2px solid #F39939;
    background-size: contain;
    position: absolute;
    bottom: 10px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;left: 5px;
  }

  .icon-label .fa-wrapper {
    border-radius: 50%;
  }

  .account-name {
    color: #fff;
    position: absolute;
    bottom: 50px;
    left: 120px;
    font-size: 20px;
    line-height: 0;
    padding: 0;
    border: none;
    background: transparent;
  }

  .account-id {
    color: #fff;
    position: absolute;
    bottom: 15px;
    left: 120px;
    font-size: 12px;
  }
}

</style>
